module.exports = __webpack_public_path__ + "img/11.7665dd40.webp";